const comments = [
  {
    name: '追剧小达人',
    text: '用了丫丫影院快三年了，真的是最良心的影视平台！更新速度没得说，画质清晰还不卡，强烈推荐给所有追剧的姐妹们。',
    time: '3天前',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20warm%20smile%2C%20casual%20style%2C%20soft%20natural%20lighting%2C%20clean%20simple%20background%2C%20friendly%20expression&width=100&height=100&seq=avatar-01-2026&orientation=squarish',
  },
  {
    name: '电影发烧友老张',
    text: '作为一个看了20年电影的老影迷，丫丫影院的片库丰富度真的让我惊喜。很多冷门佳作都能找到，清晰度和字幕质量都很到位，五星好评！',
    time: '1周前',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Asian%20man%20portrait%20with%20glasses%2C%20intellectual%20look%2C%20casual%20attire%2C%20warm%20indoor%20lighting%2C%20friendly%20and%20confident%20expression&width=100&height=100&seq=avatar-02-2026&orientation=squarish',
  },
  {
    name: '动漫控小鱼',
    text: '丫丫影院的动漫资源太全了！追新番、补老番都在这，字幕组翻译质量很高。投屏到电视看简直不要太爽，感谢丫丫让我找到组织！',
    time: '2天前',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20person%20with%20colorful%20hair%2C%20anime%20fan%20style%2C%20bright%20smile%2C%20casual%20vibrant%20outfit%2C%20clean%20simple%20background%2C%20energetic%20and%20happy%20expression&width=100&height=100&seq=avatar-03-2026&orientation=squarish',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            用户口碑
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            用户反馈
          </h2>
          <p className="mt-2 text-foreground-500 text-sm md:text-base">
            来自真实用户的观影体验分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((item) => (
            <div
              key={item.name}
              className="bg-white rounded-2xl p-6 md:p-7"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                "{item.text}"
              </p>
              <div className="flex items-center gap-1 mt-4 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-sm"></i>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}